import React from 'react'
import { useLocation } from 'react-router-dom'
import { Button, Box } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import LanguageSelect from './LanguageSelect'

const NotLoggedInToolBar = () => {
  const location = useLocation()

  const isRegister = location.pathname.includes('register')

  // Debug: Log the current path and isRegister status
  console.log('Current pathname:', location.pathname)
  console.log('isRegister:', isRegister)

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      {/* Show buttons always for now to test - remove !isRegister condition temporarily */}
      {/* {true && (
        <>
          <Button
            component={RouterLink}
            to="/student/register"
            variant="contained"
            sx={{
              backgroundColor: '#ff6b35',
              color: 'white',
              borderRadius: '8px',
              paddingX: '20px',
              paddingY: '8px',
              fontSize: '14px',
              fontWeight: 600,
              textTransform: 'none',
              minHeight: '40px',
              textDecoration: 'none',
              '&:hover': {
                backgroundColor: '#e55a2b',
                color: '#f3efedff',
              },
            }}
          >
            Become a Student
          </Button>


          <Button
            component={RouterLink}
            to="/tutor/register"
            variant="contained"
            sx={{
              backgroundColor: '#ff6b35',
              color: 'white',
              borderRadius: '8px',
              paddingX: '20px',
              paddingY: '8px',
              fontSize: '14px',
              fontWeight: 600,
              textTransform: 'none',
              minHeight: '40px',
              textDecoration: 'none',
              '&:hover': {
                backgroundColor: '#e55a2b',
                color: '#f6f1efff',
              },
            }}
          >
            Become a Tutor
          </Button>
        </>
      )} */}

      {/* Login Button */}
      {/* <Button
        component={RouterLink}
        to="/login"
        variant="outlined"
        sx={{
          color: '#f6f1efff',
          borderColor: '#ff6b35',
          backgroundColor: '#ff6b35',
          borderRadius: '8px',
          paddingX: '20px',
          paddingY: '8px',
          fontSize: '14px',
          fontWeight: 600,
          textTransform: 'none',
          minHeight: '40px',
          textDecoration: 'none',
          '&:hover': {
            backgroundColor: '#e55a2b',
            borderColor: '#e55a2b',
            color: '#f6f1efff',
          },
        }}
      >
        Login
      </Button> */}

      {/* Language Selector Component */}
      <LanguageSelect />
    </Box>
  )
}

export default NotLoggedInToolBar
